import { Card, message, Spin, Tag } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { useLocation } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";

const ViewEstimate = () => {
  const location = useLocation();

  const estimate = location.state?.estimate;
  const [estimateDetails, setEstimateDetails] = useState(null);
  const [estimateProducts, setEstimateProducts] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const getEstimateDetails = async () => {
    try {
      setPageLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}estimates/GetEstimate/${estimate.id}`,
      );

      const data = await response.json();

      if (data.Status) {
        setEstimateDetails(data.Estimate);

        const mergedProducts = data.Itemable.map((item, index) => ({
          ...item,
          ...(data.RelatedItems[index] || {}),
        }));

        setEstimateProducts(mergedProducts);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    getEstimateDetails();
  }, [estimate]);

  return (
    <Base>
      {pageLoading ? (
        <div className="text-center mt-5">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <Card className="shadow-sm border-0 mb-3">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h5 className="mb-1">
                  {estimateDetails.prefix}-{estimateDetails.number}
                </h5>

                <small className="text-muted">
                  <i className="fas fa-user me-2"></i>
                  Client #{estimateDetails.clientid}
                </small>
              </div>

              <div className="text-end">
                <Tag color="blue">
                  {estimateDetails.status === 1 ? "Draft" : "Sent"}
                </Tag>

                <br />

                <small className="text-muted">
                  <i className="fas fa-user me-2"></i>
                  {estimateDetails.AddedByName}
                </small>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-6">
                <div className="d-flex">
                  <i className="fas fa-calendar-alt text-primary me-2 mt-1"></i>

                  <div>
                    <small className="text-muted">Estimate Date</small>

                    <h6>{dayjs(estimateDetails.date).format("DD MMM YYYY")}</h6>
                  </div>
                </div>
              </div>

              <div className="col-6">
                <div className="d-flex">
                  <i className="fas fa-hourglass-end text-danger me-2 mt-1"></i>

                  <div>
                    <small className="text-muted">Expiry Date</small>

                    <h6>
                      {dayjs(estimateDetails.expirydate).format("DD MMM YYYY")}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          <Card className="shadow-sm border-0 mb-3">
            <h6 className="mb-3">
              <i className="fas fa-map-marker-alt text-danger me-2"></i>
              Billing Address
            </h6>

            <div className="row">
              <div className="col-6 mb-2">
                <i className="fas fa-road text-primary me-2"></i>

                {estimateDetails.billing_street}
              </div>

              <div className="col-6 mb-2">
                <i className="fas fa-city text-success me-2"></i>

                {estimateDetails.billing_city}
              </div>

              <div className="col-6 mb-2">
                <i className="fas fa-map text-warning me-2"></i>

                {estimateDetails.billing_state}
              </div>

              <div className="col-6">
                <i className="fas fa-mail-bulk text-secondary me-2"></i>

                {estimateDetails.billing_zip}
              </div>
            </div>
          </Card>

          {estimateProducts.map((product, index) => {
            const amount = Number(product.qty) * Number(product.rate);

            return (
              <Card key={index} className="shadow-sm border-0 mb-3">
                <div className="d-flex justify-content-between">
                  <div>
                    <h6>{product.description}</h6>
                  </div>

                  <div className="text-end">
                    <div className="fw-bold">
                      ₹{Number(product.rate).toLocaleString()}
                    </div>

                    <small className="text-muted">Per Unit</small>
                  </div>
                </div>

                <hr />

                <div className="row text-center">
                  <div className="col">
                    <small className="text-muted d-block">Qty</small>

                    <strong>{product.qty}</strong>
                  </div>

                  <div className="col">
                    <small className="text-muted d-block">Unit</small>

                    <strong>{product.unit}</strong>
                  </div>

                  <div className="col">
                    <small className="text-muted d-block">Amount</small>

                    <strong>₹{amount.toLocaleString()}</strong>
                  </div>
                </div>
              </Card>
            );
          })}

          <Card className="shadow-sm border-0">
            <h6 className="mb-3">Estimate Summary</h6>

            <div className="d-flex justify-content-between mb-2">
              <span>Subtotal</span>

              <strong>
                ₹{Number(estimateDetails.subtotal).toLocaleString()}
              </strong>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>Tax</span>

              <strong>
                ₹{Number(estimateDetails.total_tax).toLocaleString()}
              </strong>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>Discount</span>

              <strong>
                ₹{Number(estimateDetails.discount_total).toLocaleString()}
              </strong>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>Adjustment</span>

              <strong>
                ₹{Number(estimateDetails.adjustment).toLocaleString()}
              </strong>
            </div>

            <hr />

            <div className="d-flex justify-content-between">
              <h5>Total</h5>

              <h4 className="text-success">
                ₹{Number(estimateDetails.total).toLocaleString()}
              </h4>
            </div>
          </Card>
        </>
      )}

      <Footer />
    </Base>
  );
};

export default ViewEstimate;
